import {
  ContentSubmission,
  ContentSubmissionKind,
  ContentSubmissionState,
} from '@/types/contentSubmission';
import {ContentSubmissionSort, SortDir} from '@/types/sorting';
import api from '../index';

export type {ContentSubmissionKind, ContentSubmissionState};

const DEFAULT_INCLUDES = [
  'profile',
  'child_content_submissions.versions',
  'versions.content_submission_comments',
];

const DEFAULT_PER_PAGE = 20;

export type CampaignContentSubmissionsParams = {
  campaignId: string;
  state?: ContentSubmissionState | ContentSubmissionState[] | string;
  kind?: ContentSubmissionKind;
  deliverableKind?: string;
  q?: string;
  contractId?: string;
  profileId?: string;
  domain?: 'off-platform';
  page?: number;
  perPage?: number;
  include?: string[];
  sortBy?: ContentSubmissionSort;
  sortDir?: SortDir;
};

export type ContentSubmissionsMetaStats = {
  totalContentSubmissionsCount: number;
  totalPendingCount: number;
  totalArchivedCount: number;
  totalRejectedCount: number;
  totalAcceptedCount: number;
};

export type ContentSubmissionsListResponse = {
  data: ContentSubmission[];
  meta: {
    pagination: {
      currentPage: number;
      totalPages: number;
      totalEntries: number;
    };
    stats: ContentSubmissionsMetaStats;
  };
};

export type ContentSubmissionsMetaItem = {
  id: string;
  kind: string;
  contractId: string | null;
};

const campaignContentSubmissionFetchers = {
  list: async (
    params: CampaignContentSubmissionsParams
  ): Promise<ContentSubmissionsListResponse> => {
    const {
      campaignId,
      state,
      kind,
      deliverableKind,
      q,
      contractId,
      profileId,
      perPage = DEFAULT_PER_PAGE,
      page = 1,
      domain,
      include,
      sortBy,
      sortDir,
    } = params;

    const result = await api.get(
      `/campaigns/${campaignId}/content_submissions`,
      {
        params: {
          page,
          per_page: perPage,
          state,
          kind,
          deliverable_kind: deliverableKind,
          q,
          contract_id: contractId,
          profile_id: profileId,
          domain,
          include: include || DEFAULT_INCLUDES,
          sort_by: sortBy,
          sort_dir: sortDir,
        },
      }
    );

    return result as unknown as ContentSubmissionsListResponse;
  },

  meta: async (
    params: Pick<
      CampaignContentSubmissionsParams,
      | 'campaignId'
      | 'state'
      | 'contractId'
      | 'kind'
      | 'profileId'
      | 'sortBy'
      | 'sortDir'
    >
  ): Promise<ContentSubmissionsMetaItem[]> => {
    const {campaignId, state, contractId, kind, profileId, sortBy, sortDir} =
      params;

    const result = await api.get(
      `/campaigns/${campaignId}/content_submissions/content_submissions_meta`,
      {
        params: {
          state,
          contract_id: contractId,
          kind,
          profile_id: profileId,
          sort_by: sortBy,
          sort_dir: sortDir,
        },
      }
    );

    return result.data as ContentSubmissionsMetaItem[];
  },
};

export default campaignContentSubmissionFetchers;
